import {RequiredFields} from "loan-application/utils";

export enum EventName {
    PERSONAL_RESIDENCE_INFORMATION = "Personal Residence Information",
    PERSONAL_BASIC_INFORMATION = "Personal Basic Information",
    EDUCATION_AND_EMPLOYMENT_INFORMATION = "Education & Employment Information",
    APPLY_LOAN_REFERENCES = "Apply Loan References",
    BANK_DETAILS = "Bank Details",
    LOAN_REQUIREMENT = "Loan Requirement",
    APPLY_LOAN_DOCUMENTS = "Apply Loan Documents",
    APPLY_FOR_LOAN = "Apply for Loan",
    PROFILE_UPDATE = "PROFILE_UPDATE",
}




export const eventFields = {
    alternateAddresses: "Current Address",
    gender: "Gender",
    resTenure: "Staying Since",
    residentType: "Resident type",
    mothersName: "Mothers Name",
    fatherOrSpouseName: "Fathers Name",
    numDependents: "Dependents",
    relationshipStatus: "Relationship Status",
    permAddress: "Permanent Address",
    education: "Highest Education",
    workExperienceMonths: "Total Work Exp",
    employerType: "Type of Company",
    employeeId: "Employee ID (Optional)",
    designation: "Designation",
    duration: "Working Since",
    netMonthlyIncome: "Net Monthly Income",
    livingWith: "Living with",
    employmentType: "Employment Type",
    workAddress: "Work address",
};

const EventNames  = {
    [RequiredFields.PERSONAL_DETAILS]: "Personal Basic Information",
    [RequiredFields.EDUCATION_AND_EMPLOYMENT]: "Education & Employment Information",
    [RequiredFields.REFERENCES]: "Apply Loan References",
    [RequiredFields.BANK_DETAILS]: "Bank Details",
    [RequiredFields.LOAN_DETAILS]: "Loan Requirement",
};
const listOfBooleanFields = new Set(["alternateAddresses", "permAddress", "workAddress", "references", "bankAccounts"]);
const valuesToDate = new Set(["resTenure", "duration"]);

export const GetEventDetails = (selectedField, value) => {
    const eventValues = {};
    Object.keys(value).forEach((identifier) => {
        if (eventFields[identifier]) {
            if (valuesToDate.has(identifier)) {
                eventValues[eventFields[identifier]] =  new Date(value[identifier]).toDateString();
                return;
            }
            if (listOfBooleanFields.has(identifier)) {
                if (identifier === "alternateAddresses") {
                    eventValues["Current Address Pincode"] = value[identifier][0].pincode;
                }
                if (identifier === "permAddress") {
                    eventValues["Permanent Address Pincode"] = value[identifier][0].pincode;
                }
                eventValues[eventFields[identifier]] = true;
                return;
            }
            eventValues[eventFields[identifier]] = value[identifier];
        } else if (identifier === "financeBasicInfo") {
            Object.keys(value[identifier]).forEach((info) => {
                if (eventFields[info]) {
                    eventValues[eventFields[info]] = value[identifier][info];
                }
            });
        }
    });
    return {eventValues, eventName: EventNames[selectedField]};
};
